/**
 * User Register Setup
 * Initialization / dependency wiring
 */

import { FormBase } from "../../util/form-base-form";
import { UserRegisterForm } from "./user-register-form";
import { UserRegisterHandler } from "./user-register-handler";
import { UserRegisterListener } from "./user-register-listener";

class UserRegisterSetupFormBase extends FormBase {
    public getForm(root: ParentNode): HTMLFormElement | null {
        return super.getForm(root, "form");
    }
}

const userRegisterSetupFormBase = new UserRegisterSetupFormBase();

export class UserRegisterSetup {
    public static init(el: Element): void {
        if (!(el instanceof HTMLFormElement)) {
            const formEl = userRegisterSetupFormBase.getForm(el);
            if (!(formEl instanceof HTMLFormElement)) return;
            return this.init(formEl);
        }

        el.setAttribute("data-validation-attached", "true");

        const form = new UserRegisterForm(el);
        const handler = new UserRegisterHandler(form);
        const listener = new UserRegisterListener(form, handler);

        listener.attach();
    }
}
